var React = require('react');

function SimpleLockInline (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M36.4167 21.6727H9.58333C7.46624 21.6727 5.75 23.3889 5.75 25.506V38.9227C5.75 41.0398 7.46624 42.756 9.58333 42.756H36.4167C38.5338 42.756 40.25 41.0398 40.25 38.9227V25.506C40.25 23.3889 38.5338 21.6727 36.4167 21.6727Z","stroke":"white","strokeWidth":"3.83333","strokeLinecap":"round","strokeLinejoin":"round","key":0}),React.createElement("path",{"d":"M13.4166 21.6727V14.006C13.4166 11.4644 14.4263 9.0268 16.2235 7.22958C18.0207 5.43235 20.4583 4.42268 23 4.42268C25.5416 4.42268 27.9792 5.43235 29.7764 7.22958C31.5736 9.0268 32.5833 11.4644 32.5833 14.006V21.6727","stroke":"white","strokeWidth":"3.83333","strokeLinecap":"round","strokeLinejoin":"round","key":1})]);
}

SimpleLockInline.defaultProps = {"width":"46","height":"47","viewBox":"0 0 46 47","fill":"none"};

module.exports = SimpleLockInline;

SimpleLockInline.default = SimpleLockInline;
